import fetch from 'common/js/fetch';
import {setUser, setRoleInfo, getRoleCode, getUserName, getUserRealName} from 'common/js/util';

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGOUT = 'LOGOUT';
const LOAD_DATA = 'LOAD_DATA';
const LOADING = 'LOADING';
const CANCEL_LOADING = 'CANCEL_LOADING';
const NEED_CHANGE_PWD = 'NEED_CHANGE_PWD';
const CANCEL_CHANGE_PWD = 'CANCEL_CHANGE_PWD';

const initState = {
    fetching: false,
    redirectTo: '',
    msg: '',
    loginName: getUserName() || '',
    realName: getUserRealName() || '',
    roleCode: getRoleCode() || '',
    kind: '',
    needChangePwd: false,
    pwdMobile: ''
};

export function user(state = initState, action) {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {...state, msg: ''};
        case LOAD_DATA:
            return {...state, ...action.payload, redirectTo: '/'};
        case LOGOUT:
            return {...initState, redirectTo: '/login'};
        case LOADING:
            return {...state, fetching: true};
        case CANCEL_LOADING:
            return {...state, fetching: false};
        case NEED_CHANGE_PWD:
            return {
                ...state,
                needChangePwd: true,
                pwdMobile: action.payload.mobile || ''
            };
        case CANCEL_CHANGE_PWD:
            return {...state, needChangePwd: false};
        default:
            return state;
    }
}

// 登录成功
function loginSuccess(data) {
    return {type: LOGIN_SUCCESS, payload: data};
}

function doFetching() {
    return {type: LOADING};
}

export function cancelFetching() {
    return {type: CANCEL_LOADING};
}

// 弱密码登录，需要修改密码
function needChangePwd({mobile}) {
    return {type: NEED_CHANGE_PWD, payload: {mobile}};
}

// 关闭弱密码提示弹窗
export function closeChangePwdModal() {
    return {type: CANCEL_CHANGE_PWD};
}

// 获取用户信息成功
export function loadData(data) {
    setRoleInfo(data);
    return {type: LOAD_DATA, payload: data};
}

// 获取用户信息
export function getUser() {
    return dispatch => {
        dispatch(doFetching());
        _getUser().then(data => {
            dispatch(loadData(data));
            dispatch(cancelFetching());
        }).catch(msg => {
            dispatch(cancelFetching());
        });
    };
}

// 登录
export function login({loginName, loginPwd}) {
    return dispatch => {
        dispatch(doFetching());
        // OPS
        fetch('/auth/v1/user/login/sys', {

            // 数据中心
            // fetch('/auth/v1/user/login/net', {

            // 单位自管
            // fetch('/auth/v1/user/login/owner', {
            loginName,
            loginPwd,
            clientType: 'web'

            // 其他
            // companyId: '0'
        }).then(data => {
            // 弱密码：弹窗提示修改密码，中断登录流程
            if (data && data.needChangePwd) {
                dispatch(needChangePwd({mobile: data.mobile}));
                dispatch(cancelFetching());
                return null;
            }
            setUser(data);
            fetch('/auth/v1/config/public/pic_config').then(data => {
                sessionStorage.setItem('upload_url', data.upload_url_sys + '/');
                sessionStorage.setItem('domain_url', data.domain_url);
            });
            dispatch(loginSuccess());
            return _getUser().then(data => {
                dispatch(cancelFetching());
                dispatch(loadData(data));
            });
        }).catch(msg => {
            dispatch(cancelFetching());
        });
    };
}

function _getUser() {
    return fetch('/auth/v1/user/permission_none/my', {});
}
